import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "flex-shrink-0 flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "text-sm text-slate-500 mt-0.5"
};
const _hoisted_4 = {
  class: "flex-1 overflow-y-auto min-h-0 p-6"
};
const _hoisted_5 = {
  class: "max-w-3xl mx-auto"
};
const _hoisted_6 = {
  class: "space-y-5"
};
const _hoisted_7 = {
  class: "grid grid-cols-1 md:grid-cols-3 gap-4"
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = ["value"];
const _hoisted_10 = {
  class: "grid grid-cols-1 md:grid-cols-2 gap-4"
};
const _hoisted_11 = {
  class: "grid grid-cols-1 md:grid-cols-2 gap-4"
};
const _hoisted_12 = {
  class: "relative"
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  class: "border-t border-slate-200 pt-4"
};
const _hoisted_15 = {
  class: "flex items-center justify-between mb-3"
};
const _hoisted_16 = {
  class: "flex gap-2"
};
const _hoisted_17 = {
  key: 0,
  class: "space-y-2"
};
const _hoisted_18 = {
  key: 0,
  class: "px-2 py-0.5 rounded text-xs bg-green-100 text-green-700 whitespace-nowrap"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  key: 1,
  class: "text-center py-4 text-slate-500 text-sm bg-slate-50 rounded-lg"
};
const _hoisted_21 = {
  class: "mt-3 flex items-center justify-end gap-4"
};
const _hoisted_22 = {
  key: 0,
  class: "text-xs text-red-600"
};
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = {
  class: "flex items-center gap-3 mb-3"
};
const _hoisted_25 = {
  class: "text-sm font-medium text-slate-700"
};
const _hoisted_26 = {
  class: "flex-shrink-0 px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-3"
};
const _hoisted_27 = ["disabled"];
import { ref, reactive, computed, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { addOrderToPlan, editOrder } from '@/api/order';
import { getProductCategories } from '@/api/product';
import ProductPicker from '@/components/ProductPicker.vue';
import OrderServiceRemindersEditor from '@/components/OrderServiceRemindersEditor.vue';
import UserSelector from '@/components/UserSelector/index.vue';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'OrderFormModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: null
    },
    planId: {
      type: [String, Number],
      default: null
    }
  },
  emits: ['update:visible', 'success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const submitting = ref(false);
    const categories = ref([]);
    const orderForm = reactive({
      productId: '',
      orderType: 'ONCE',
      periodCount: null,
      serviceStart: '',
      serviceEnd: '',
      amount: 0,
      remark: '',
      executorId: null,
      billings: [],
      productNeedOrderReminder: 0,
      serviceReminderRequired: null,
      orderReminderPrompt: '',
      serviceReminders: []
    });

    // 服务提醒区块是否被用户改动过（编辑模式的 null 语义：未触碰则后端保留存量）
    const serviceRemindersTouched = ref(false);

    // 产品选择变化：记录该产品的"单独设置服务提醒"开关与提示语；开关开启时默认选「是」
    const handleProductChange = product => {
      orderForm.productNeedOrderReminder = product?.needOrderReminder ?? 0;
      orderForm.orderReminderPrompt = product?.orderReminderPrompt ?? '';
      orderForm.serviceReminderRequired = orderForm.productNeedOrderReminder === 1 ? 1 : null;
    };

    // 是/否开关变化视同触碰提醒区块（编辑模式 null 语义：触碰后随命令携带全量提醒或空数组）
    const handleServiceReminderRequiredChange = () => {
      serviceRemindersTouched.value = true;
    };

    // 将分钟间隔拆为值+单位（与 ProposalFormModal 同款）
    const normalizeRepeatInterval = minutes => {
      const value = minutes || 60;
      if (value % 1440 === 0) return {
        repeatIntervalValue: value / 1440,
        repeatIntervalUnit: 'DAY'
      };
      if (value % 60 === 0) return {
        repeatIntervalValue: value / 60,
        repeatIntervalUnit: 'HOUR'
      };
      return {
        repeatIntervalValue: value,
        repeatIntervalUnit: 'MINUTE'
      };
    };

    // 执行中的订单不允许变更产品和订单类型
    const isExecuting = computed(() => props.isEdit && props.editData?.status === 1);

    // 编辑模式下用于产品选择器回显的当前产品
    const initialProduct = computed(() => {
      const data = props.editData;
      if (props.isEdit && data?.productId && data.productNameSnapshot) {
        return {
          id: data.productId,
          name: data.productNameSnapshot,
          code: data.productCodeSnapshot || ''
        };
      }
      return null;
    });
    const displayProductText = computed(() => {
      const p = initialProduct.value;
      if (!p) return '—';
      return p.code ? `${p.name} (${p.code})` : p.name;
    });

    // 计算账单总额
    const billingTotal = computed(() => {
      if (!orderForm.billings || orderForm.billings.length === 0) return 0;
      return orderForm.billings.reduce((sum, b) => sum + (b.amount || 0), 0);
    });

    // 按付款日期排序的账单列表（用于展示，自动计算期数）
    const sortedBillings = computed(() => {
      if (!orderForm.billings || orderForm.billings.length === 0) return [];
      return [...orderForm.billings].map((b, originalIndex) => ({
        ...b,
        _originalIndex: originalIndex
      })).sort((a, b) => {
        if (!a.dueDate && !b.dueDate) return 0;
        if (!a.dueDate) return 1;
        if (!b.dueDate) return -1;
        return new Date(a.dueDate) - new Date(b.dueDate);
      }).map((b, sortedIndex) => ({
        ...b,
        _sortedPeriodIndex: sortedIndex + 1
      }));
    });

    // 账单金额是否与订单金额一致
    const isBillingTotalValid = computed(() => {
      return Math.abs(billingTotal.value - (orderForm.amount || 0)) < 0.01;
    });

    // 判断账单是否已收款（已收/部分收/已核销）
    const isBillingPaid = billing => {
      return billing.status >= 1;
    };
    const billingStatusTextMap = {
      0: '待收',
      1: '已收',
      2: '部分收',
      3: '已核销'
    };
    const getBillingStatusText = status => billingStatusTextMap[status] || '';

    // 加载产品分类
    const loadCategories = async () => {
      try {
        const data = await getProductCategories();
        categories.value = data || [];
      } catch (error) {
        console.error('加载产品分类失败', error);
      }
    };
    const handleOrderTypeChange = () => {
      if (orderForm.orderType === 'ONCE') {
        orderForm.periodCount = null;
      } else {
        orderForm.periodCount = 1;
      }
      orderForm.billings = [];
    };

    // 自动生成账单
    const generateBillings = () => {
      if (!orderForm.amount || orderForm.amount <= 0) {
        ElMessage.warning('请先输入订单金额');
        return;
      }
      const periodCount = orderForm.orderType === 'PERIODIC' ? orderForm.periodCount || 1 : 1;
      const amountPerPeriod = orderForm.amount / periodCount;
      const startDate = orderForm.serviceStart ? new Date(orderForm.serviceStart) : new Date();
      const bills = [];
      for (let i = 1; i <= periodCount; i++) {
        const dueDate = new Date(startDate);
        dueDate.setMonth(dueDate.getMonth() + (i - 1));
        const dueDateStr = dueDate.toISOString().split('T')[0];
        bills.push({
          periodIndex: i,
          amount: Number(amountPerPeriod.toFixed(2)),
          dueDate: dueDateStr
        });
      }
      orderForm.billings = bills;
    };
    const addBilling = () => {
      if (!orderForm.billings) orderForm.billings = [];
      const maxPeriod = orderForm.billings.reduce((max, b) => Math.max(max, b.periodIndex || 0), 0);
      orderForm.billings.push({
        periodIndex: maxPeriod + 1,
        amount: 0,
        dueDate: ''
      });
    };
    const removeBilling = index => {
      orderForm.billings.splice(index, 1);
    };

    // 表单验证
    const validateForm = () => {
      if (!orderForm.productId) {
        ElMessage.warning('请选择产品');
        return false;
      }
      if (!orderForm.orderType) {
        ElMessage.warning('请选择订单类型');
        return false;
      }
      if (!orderForm.executorId) {
        ElMessage.warning('请选择落地执行人员');
        return false;
      }
      if (!orderForm.amount || orderForm.amount <= 0) {
        ElMessage.warning('请输入有效的订单金额');
        return false;
      }
      if (orderForm.orderType === 'PERIODIC' && !orderForm.periodCount) {
        ElMessage.warning('分期订单请选择分期期数');
        return false;
      }
      if (orderForm.orderType === 'PERIODIC' && orderForm.billings?.length !== orderForm.periodCount) {
        ElMessage.warning(`分期订单账单数量应为${orderForm.periodCount}期`);
        return false;
      }
      if (orderForm.billings?.some(b => !b.dueDate)) {
        ElMessage.warning('请填写所有账单的付款日期');
        return false;
      }
      if (orderForm.billings?.length > 0 && !isBillingTotalValid.value) {
        ElMessage.warning('账单金额合计与订单金额不一致');
        return false;
      }
      return true;
    };

    // 根据付款日期排序账单并分配期数
    const sortBillingsWithPeriodIndex = billings => {
      return [...billings].sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate)).map((b, index) => ({
        ...b,
        periodIndex: index + 1
      }));
    };

    // 订单服务提醒必填校验（产品开关开启且用户选择「需要」时）
    const validateServiceReminders = () => {
      if (orderForm.productNeedOrderReminder !== 1 || orderForm.serviceReminderRequired !== 1) return true;
      const enabledReminders = orderForm.serviceReminders.filter(r => r.enabled !== false);
      if (enabledReminders.length === 0) {
        ElMessage.warning('该服务产品要求至少设置一条服务提醒');
        return false;
      }
      for (const reminder of enabledReminders) {
        if (!String(reminder.reminderItem || '').trim()) {
          ElMessage.warning('请填写服务提醒的提醒事项');
          return false;
        }
        if (!Array.isArray(reminder.receiverUserIds) || reminder.receiverUserIds.length === 0) {
          ElMessage.warning('请选择服务提醒的提醒人员');
          return false;
        }
        if (reminder.repeatType === 'INTERVAL' && (!reminder.firstReminderTime || !Number.isFinite(reminder.repeatIntervalValue) || reminder.repeatIntervalValue < 1)) {
          ElMessage.warning('请完善服务提醒的常规提醒设置');
          return false;
        }
        if (reminder.repeatType === 'WEEKLY' && (!reminder.weekDay || !reminder.remindTime)) {
          ElMessage.warning('请设置服务提醒的每周提醒时间');
          return false;
        }
        if (reminder.repeatType === 'MONTHLY' && (!reminder.monthDay || !reminder.remindTime)) {
          ElMessage.warning('请设置服务提醒的每月提醒时间');
          return false;
        }
        if (reminder.endType === 'COUNT' && (!Number.isFinite(reminder.maxReminderCount) || reminder.maxReminderCount < 1)) {
          ElMessage.warning('请设置服务提醒的最大提醒次数');
          return false;
        }
        if (reminder.endType === 'SERVICE_END' && !orderForm.serviceEnd) {
          ElMessage.warning('选择服务期结束时，请先填写服务结束日期');
          return false;
        }
      }
      return true;
    };

    // 服务提醒命令映射
    const buildServiceReminders = () => orderForm.serviceReminders.map(r => ({
      reminderItem: r.reminderItem || '',
      repeatType: r.repeatType,
      firstReminderTime: r.repeatType === 'INTERVAL' ? r.firstReminderTime || undefined : undefined,
      repeatIntervalMinutes: r.repeatType === 'INTERVAL' ? r.repeatIntervalUnit === 'DAY' ? r.repeatIntervalValue * 1440 : r.repeatIntervalUnit === 'HOUR' ? r.repeatIntervalValue * 60 : r.repeatIntervalValue : undefined,
      weekDay: r.repeatType === 'WEEKLY' ? r.weekDay : undefined,
      monthDay: r.repeatType === 'MONTHLY' ? r.monthDay : undefined,
      remindTime: r.repeatType === 'INTERVAL' ? undefined : r.remindTime || undefined,
      endType: r.endType,
      maxReminderCount: r.endType === 'COUNT' ? r.maxReminderCount || 10 : undefined,
      receiverUserIds: (r.receiverUserIds || []).map(Number),
      enabled: r.enabled !== false
    }));

    // 提交
    const handleSubmit = async () => {
      if (!validateForm()) return;
      if (!validateServiceReminders()) return;
      submitting.value = true;
      try {
        if (props.isEdit) {
          const command = {
            orderId: props.editData?.id,
            productId: orderForm.productId,
            orderType: orderForm.orderType,
            periodCount: orderForm.orderType === 'PERIODIC' ? orderForm.periodCount : undefined,
            serviceStart: orderForm.serviceStart || undefined,
            serviceEnd: orderForm.serviceEnd || undefined,
            amount: orderForm.amount,
            remark: orderForm.remark || undefined,
            billings: sortBillingsWithPeriodIndex(orderForm.billings?.filter(b => b.amount > 0 && !isBillingPaid(b)) || []).map(b => ({
              id: b.id || undefined,
              periodIndex: b.periodIndex,
              amount: b.amount,
              dueDate: b.dueDate,
              remark: b.remark || undefined
            })),
            // 服务提醒选择始终携带当前值（后端 null 语义：null 不改动该列）
            serviceReminderRequired: orderForm.serviceReminderRequired,
            // 编辑模式 null 语义：未触碰提醒区块则不传，后端保留存量；选「否」视同触碰并显式传空数组清空存量
            serviceReminders: serviceRemindersTouched.value ? orderForm.serviceReminderRequired === 0 ? [] : buildServiceReminders() : undefined
          };
          const result = await editOrder(command);
          emit('success', result);
          closeModal();
        } else {
          // 新建模式
          const command = {
            planId: props.planId,
            order: {
              productId: orderForm.productId,
              orderType: orderForm.orderType,
              periodCount: orderForm.orderType === 'PERIODIC' ? orderForm.periodCount : undefined,
              serviceStart: orderForm.serviceStart || undefined,
              serviceEnd: orderForm.serviceEnd || undefined,
              amount: orderForm.amount,
              remark: orderForm.remark || undefined,
              executorId: orderForm.executorId || undefined,
              billings: sortBillingsWithPeriodIndex(orderForm.billings?.filter(b => b.amount > 0) || []),
              // 新建订单始终携带服务提醒选择（产品开关=0时为null）
              serviceReminderRequired: orderForm.serviceReminderRequired,
              // 新建订单始终携带全量服务提醒；选「否」时传空数组
              serviceReminders: orderForm.serviceReminderRequired === 0 ? [] : buildServiceReminders()
            }
          };
          const result = await addOrderToPlan(command);
          if (result.needApproval) {
            ElMessage.success('订单提交成功，已进入审批流程');
          } else {
            ElMessage.success('订单添加成功');
          }
          emit('success');
          closeModal();
        }
      } catch (error) {
        ElMessage.error(error.message || (props.isEdit ? '订单修改失败' : '订单添加失败'));
      } finally {
        submitting.value = false;
      }
    };
    const resetForm = () => {
      Object.assign(orderForm, {
        productId: '',
        orderType: 'ONCE',
        periodCount: null,
        serviceStart: '',
        serviceEnd: '',
        amount: 0,
        remark: '',
        executorId: null,
        billings: [],
        productNeedOrderReminder: 0,
        serviceReminderRequired: null,
        orderReminderPrompt: '',
        serviceReminders: []
      });
      serviceRemindersTouched.value = false;
    };
    const fillForm = data => {
      if (!data) return;
      orderForm.productId = data.productId || '';
      orderForm.orderType = data.orderType || '';
      orderForm.periodCount = data.periodCount || null;
      orderForm.serviceStart = data.serviceStart || '';
      orderForm.serviceEnd = data.serviceEnd || '';
      orderForm.amount = data.amount || 0;
      orderForm.remark = data.remark || '';
      orderForm.executorId = data.executorId || data.executor?.id || null;
      orderForm.billings = data.billings?.map(b => ({
        id: b.id,
        periodIndex: b.periodIndex,
        amount: b.amount,
        dueDate: b.dueDate,
        status: b.status ?? 0
      })) || [];

      // 回填服务提醒（含产品开关当前值）；NULL 历史数据按「是」回显，维持旧的强制语义
      orderForm.productNeedOrderReminder = data.needOrderReminder ?? 0;
      orderForm.serviceReminderRequired = data.serviceReminderRequired ?? 1;
      orderForm.orderReminderPrompt = data.orderReminderPrompt ?? '';
      orderForm.serviceReminders = (data.serviceReminders || []).map(r => {
        const {
          repeatIntervalValue,
          repeatIntervalUnit
        } = normalizeRepeatInterval(r.repeatIntervalMinutes || 60);
        return {
          _localKey: `sr_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
          id: r.id,
          enabled: r.enabled,
          reminderItem: r.reminderItem || '',
          receiverUserIds: r.receiverUserIds || [],
          repeatType: r.repeatType || 'WEEKLY',
          firstReminderTime: r.firstReminderTime ? r.firstReminderTime.replace(' ', 'T') : '',
          repeatIntervalValue,
          repeatIntervalUnit,
          weekDay: r.weekDay ?? 1,
          monthDay: r.monthDay ?? 1,
          remindTime: r.remindTime || '09:30:00',
          endType: r.endType || 'COUNT',
          maxReminderCount: r.maxReminderCount || 10
        };
      });
      serviceRemindersTouched.value = false;
    };
    const closeModal = () => {
      emit('update:visible', false);
    };
    watch(() => props.visible, val => {
      if (val) {
        loadCategories();
        if (props.isEdit && props.editData) {
          fillForm(props.editData);
        } else {
          resetForm();
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: __props.visible,
        size: "4xl",
        "z-index": 60,
        onClose: closeModal
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_2, _toDisplayString(__props.isEdit ? '编辑订单' : '新增订单'), 1), _createElementVNode("p", _hoisted_3, _toDisplayString(__props.isEdit ? '修改订单信息' : '向当前方案添加新的订单'), 1)]), _createElementVNode("button", {
          onClick: closeModal,
          class: "p-1.5 text-slate-400 hover:text-slate-600"
        }, [...(_cache[11] || (_cache[11] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [!isExecuting.value ? (_openBlock(), _createBlock(ProductPicker, {
          key: 0,
          modelValue: orderForm.productId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => orderForm.productId = $event),
          categories: categories.value,
          "initial-product": initialProduct.value,
          onChange: handleProductChange
        }, null, 8, ["modelValue", "categories", "initial-product"])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_cache[12] || (_cache[12] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, [_createTextVNode(" 产品 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createElementVNode("input", {
          value: displayProductText.value,
          readonly: "",
          class: "form-readonly w-full"
        }, null, 8, _hoisted_9)]))]), _createElementVNode("div", null, [_cache[13] || (_cache[13] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, [_createTextVNode(" 订单类型 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createVNode(_component_el_select, {
          modelValue: orderForm.orderType,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => orderForm.orderType = $event),
          placeholder: "请选择类型",
          disabled: isExecuting.value,
          class: "w-full",
          onChange: handleOrderTypeChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "一次性服务",
            value: "ONCE"
          }), _createVNode(_component_el_option, {
            label: "分期服务",
            value: "PERIODIC"
          })]),
          _: 1
        }, 8, ["modelValue", "disabled"])]), _createElementVNode("div", null, [_cache[14] || (_cache[14] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, [_createTextVNode(" 落地执行人员 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createVNode(UserSelector, {
          modelValue: orderForm.executorId,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => orderForm.executorId = $event),
          multiple: false,
          placeholder: "请选择执行人员",
          disabled: __props.isEdit
        }, null, 8, ["modelValue", "disabled"])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", null, [_cache[15] || (_cache[15] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, "服务开始时间", -1)), _createVNode(_component_el_date_picker, {
          modelValue: orderForm.serviceStart,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => orderForm.serviceStart = $event),
          type: "date",
          format: "YYYY年MM月DD日",
          "value-format": "YYYY-MM-DD",
          placeholder: "请选择开始时间",
          class: "w-full"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[16] || (_cache[16] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, "服务结束时间", -1)), _createVNode(_component_el_date_picker, {
          modelValue: orderForm.serviceEnd,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => orderForm.serviceEnd = $event),
          type: "date",
          format: "YYYY年MM月DD日",
          "value-format": "YYYY-MM-DD",
          placeholder: "请选择结束时间",
          class: "w-full"
        }, null, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", null, [_cache[18] || (_cache[18] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, [_createTextVNode(" 订单金额 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createElementVNode("div", _hoisted_12, [_cache[17] || (_cache[17] = _createElementVNode("span", {
          class: "absolute left-3 top-2.5 text-slate-500"
        }, "¥", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => orderForm.amount = $event),
          type: "number",
          step: "0.01",
          class: "w-full pl-7 pr-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500",
          placeholder: "0.00"
        }, null, 512), [[_vModelText, orderForm.amount, void 0, {
          number: true
        }]])])]), orderForm.orderType === 'PERIODIC' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_cache[19] || (_cache[19] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, [_createTextVNode(" 分期期数 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _createVNode(_component_el_select, {
          modelValue: orderForm.periodCount,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => orderForm.periodCount = $event),
          placeholder: "请选择期数",
          class: "w-full"
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, n => {
            return _createVNode(_component_el_option, {
              key: n,
              label: `${n}期`,
              value: n
            }, null, 8, ["label", "value"]);
          }), 64))]),
          _: 1
        }, 8, ["modelValue"])])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_cache[20] || (_cache[20] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-2"
        }, "备注", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => orderForm.remark = $event),
          type: "text",
          class: "w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent",
          placeholder: "请输入备注（可选）"
        }, null, 512), [[_vModelText, orderForm.remark]])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_cache[22] || (_cache[22] = _createElementVNode("div", {
          class: "flex items-center gap-2"
        }, [_createElementVNode("svg", {
          class: "w-4 h-4 text-slate-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
        })]), _createElementVNode("span", {
          class: "text-sm font-medium text-slate-700"
        }, "账单明细")], -1)), _createElementVNode("div", _hoisted_16, [_createElementVNode("button", {
          onClick: addBilling,
          class: "text-slate-600 text-sm hover:text-slate-800 font-medium px-2 py-1 hover:bg-slate-100 rounded"
        }, " + 手动添加 "), !__props.isEdit ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: generateBillings,
          class: "text-primary-600 text-sm hover:text-primary-700 font-medium px-2 py-1 hover:bg-primary-50 rounded"
        }, [...(_cache[21] || (_cache[21] = [_createElementVNode("svg", {
          class: "w-4 h-4 inline mr-1",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        })], -1), _createTextVNode(" 自动生成 ", -1)]))])) : _createCommentVNode("", true)])]), sortedBillings.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_cache[25] || (_cache[25] = _createElementVNode("div", {
          class: "flex items-center gap-3 px-3 pb-2 text-xs text-slate-500"
        }, [_createElementVNode("span", {
          class: "w-16 text-center"
        }, "期数"), _createElementVNode("span", {
          class: "w-40"
        }, "金额"), _createElementVNode("span", {
          class: "w-44"
        }, "付款日期"), _createElementVNode("span", {
          class: "w-8"
        })], -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedBillings.value, billing => {
          return _openBlock(), _createElementBlock("div", {
            key: billing._originalIndex,
            class: _normalizeClass(['flex items-center gap-3 p-3 rounded-lg', isBillingPaid(billing) ? 'bg-slate-100 opacity-70' : 'bg-slate-50'])
          }, [_createVNode(_component_el_input, {
            "model-value": billing._sortedPeriodIndex,
            disabled: "",
            class: "!w-16"
          }, null, 8, ["model-value"]), _createVNode(_component_el_input, {
            modelValue: orderForm.billings[billing._originalIndex].amount,
            "onUpdate:modelValue": $event => orderForm.billings[billing._originalIndex].amount = $event,
            modelModifiers: {
              number: true
            },
            type: "number",
            disabled: isBillingPaid(billing),
            placeholder: "0.00",
            class: "!w-40"
          }, {
            prefix: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode("¥", -1)]))]),
            _: 1
          }, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), _createVNode(_component_el_date_picker, {
            modelValue: orderForm.billings[billing._originalIndex].dueDate,
            "onUpdate:modelValue": $event => orderForm.billings[billing._originalIndex].dueDate = $event,
            type: "date",
            format: "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            placeholder: "到期日",
            disabled: isBillingPaid(billing),
            class: "!w-44"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), isBillingPaid(billing) ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(getBillingStatusText(billing.status)), 1)) : (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: $event => removeBilling(billing._originalIndex),
            class: "p-1 text-red-500 hover:text-red-700 flex-shrink-0"
          }, [...(_cache[24] || (_cache[24] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))], 8, _hoisted_19))], 2);
        }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_20, " 暂无账单，可手动添加或自动生成 ")), _createElementVNode("div", _hoisted_21, [_cache[26] || (_cache[26] = _createElementVNode("span", {
          class: "text-sm text-slate-600"
        }, "账单金额合计: ", -1)), _createElementVNode("span", {
          class: _normalizeClass(['font-medium', isBillingTotalValid.value ? 'text-green-600' : 'text-red-600'])
        }, " ¥" + _toDisplayString(billingTotal.value.toLocaleString()), 3), !isBillingTotalValid.value ? (_openBlock(), _createElementBlock("span", _hoisted_22, "（与订单金额不一致）")) : _createCommentVNode("", true)])]), orderForm.productNeedOrderReminder === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("span", _hoisted_25, [_createTextVNode(_toDisplayString(orderForm.orderReminderPrompt || '是否需要服务提醒') + " ", 1), _cache[27] || (_cache[27] = _createElementVNode("span", {
          class: "text-red-500"
        }, "*", -1))]), _createVNode(_component_el_radio_group, {
          modelValue: orderForm.serviceReminderRequired,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => orderForm.serviceReminderRequired = $event),
          onChange: handleServiceReminderRequiredChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            value: 1
          }, {
            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [_createTextVNode("是", -1)]))]),
            _: 1
          }), _createVNode(_component_el_radio, {
            value: 0
          }, {
            default: _withCtx(() => [...(_cache[29] || (_cache[29] = [_createTextVNode("否", -1)]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]), orderForm.serviceReminderRequired === 1 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_cache[30] || (_cache[30] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createTextVNode(" 订单服务提醒 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _cache[31] || (_cache[31] = _createElementVNode("p", {
          class: "mb-2 text-xs text-slate-500"
        }, "该服务产品要求单独设置服务提醒，默认提醒订单创建人、执行人及执行人部门负责人", -1)), _createVNode(OrderServiceRemindersEditor, {
          rows: orderForm.serviceReminders,
          "onUpdate:rows": _cache[9] || (_cache[9] = $event => orderForm.serviceReminders = $event),
          "executor-id": orderForm.executorId,
          locked: true,
          onTouched: _cache[10] || (_cache[10] = $event => serviceRemindersTouched.value = true)
        }, null, 8, ["rows", "executor-id"])], 64)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("button", {
          onClick: closeModal,
          class: "px-5 py-2.5 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50"
        }, " 取消 "), _createElementVNode("button", {
          onClick: handleSubmit,
          disabled: submitting.value,
          class: "px-5 py-2.5 bg-primary-700 text-white rounded-lg hover:bg-primary-800 disabled:opacity-50 disabled:cursor-not-allowed"
        }, _toDisplayString(submitting.value ? '提交中...' : __props.isEdit ? '保存' : '提交订单'), 9, _hoisted_27)])]),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};